import { Link, LinkProps } from "react-router-dom"
import { Typography } from "matsuri-ui"
import { css } from "@emotion/react"
import { theme } from "../theme"

const makeStyle = ({
    variant = "text",
    color = "default",
    disabled = false
}: Pick<FooterIconButtonProps, "variant" | "color" | "disabled">) => {
    return css`
        display: grid;
        gap: 4px;
        justify-content: center;
        padding: 8px 0;
        color: ${
            disabled
                ? theme.palette.intentions.cleanerGray.main
                : variant === "filled" && color === "primary"
                  ? "white"
                  : variant === "text" && color === "primary"
                    ? theme.palette.intentions.primary.main
                    : theme.palette.intentions.text.primary
        };
        background-color: ${
            variant === "filled" && color === "primary"
                ? theme.palette.intentions.primary.main
                : "transparent"
        };
        border-radius: 6px;
    `
}

interface FooterIconButtonProps extends React.PropsWithChildren {
    variant?: "filled" | "text"
    color?: "default" | "primary"
    icon?: React.ReactNode
    disabled?: boolean
}

export const FooterIconButton = ({
    icon,
    children,
    color,
    variant,
    disabled,
    ...buttonProps
}: React.ComponentPropsWithoutRef<"button"> & FooterIconButtonProps) => {
    return (
        <button
            {...buttonProps}
            disabled={disabled}
            css={makeStyle({
                variant,
                color,
                disabled
            })}
        >
            <div
                css={css`
                    display: grid;
                    justify-content: center;
                `}
            >
                {icon}
            </div>
            <div>
                <Typography
                    css={css`
                        font-size: 12px;
                        font-weight: 700;
                    `}
                >
                    {children}
                </Typography>
            </div>
        </button>
    )
}

export const FooterIconButtonAsLink = ({
    icon,
    children,
    color,
    variant,
    disabled,
    ...linkProps
}: LinkProps & FooterIconButtonProps) => {
    return (
        <Link
            {...linkProps}
            css={makeStyle({
                variant,
                color,
                disabled
            })}
        >
            <div
                css={css`
                    display: grid;
                    justify-content: center;
                `}
            >
                {icon}
            </div>
            <div>
                <Typography
                    css={css`
                        font-size: 12px;
                        font-weight: 700;
                    `}
                >
                    {children}
                </Typography>
            </div>
        </Link>
    )
}
